import { Injectable } from '@angular/core';
import {
  ConfigService,
  EntityService,
  TokenService
} from 'viggo-sistemas-core-web';
import { IProcedimento } from '../models/procedimento.model';

@Injectable()
export class ProcedimentoService extends EntityService<IProcedimento> {
  constructor(
    protected configService: ConfigService,
    protected tokenService: TokenService
  ) {
    super({
      urlBackend: configService.backendURL,
      baseEntityEndPoint: 'procedimento'
    });
  }
}
